import styled from "@emotion/styled";
import React from "react";
import { Fragment } from "react";

import ArrowUpIcon from "./ArrowUpIcon";
import { TypographyT25 } from "Components/Common/Typography/index";
import { Spacer } from "Components/Common/Spacer/index";

const RateVariationT1 = (props) => {
  const { rate, isActive } = props;
  return (
    <Fragment>
      <RateVariationT1Wrapper>
        <div style={{ paddingTop: "2px" }}>
          <ArrowUpIcon />
        </div>
        <Spacer spacing={"6px"} />
        <TypographyT25 color={!!isActive ? "#FFFFFF" : ""}>
          {rate}
        </TypographyT25>
      </RateVariationT1Wrapper>
    </Fragment>
  );
};

export default RateVariationT1;

const RateVariationT1Wrapper = styled("div")`
  display: flex;
  align-items: center;
`;
